module.exports = __webpack_public_path__ + "static/media/review-bg@2x.f2a2bfb8.jpg";